module.exports = __webpack_public_path__ + "static/media/bg.4a06bfe2.jpg";